/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Include_Content2Inputs */

const en_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: Unlocked the Pro version via in-app purchase`)
};

const ar_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اندرويد: فتح قفل إصدار النسخة الا احترافي عبر عملية شراء داخل التطبيق`)
};

const de_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: Die Version Pro per In-App-Kauf freigeschaltet`)
};

const es_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: Desbloquea la versión Pro mediante la compra dentro de la app`)
};

const fr_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android : Version Pro débloquée via achat intégré`)
};

const it_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: Sbloccata la versione Pro tramite acquisto in-app`)
};

const ja_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android：アプリ内課金でPro版をアンロックされた方`)
};

const ko_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: 인앱 구매를 통해 Pro 버전을 개방한 사용자`)
};

const pt_br_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: desbloquearam a versão Pro via compra no aplicativo`)
};

const ru_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: разблокировал версию Pro через встроенную покупку`)
};

const th_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: ปลดล็อกเวอร์ชันโปรผ่านการซื้อภายในแอป`)
};

const tr_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android: Pro uygulama içi satın alma yoluyla kilidini açtım`)
};

const zh_cn_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android 内付费解锁`)
};

const zh_tw_pro_user_include_content2 = /** @type {(inputs: Pro_User_Include_Content2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android 內付費解鎖`)
};

/**
* | output |
* | --- |
* | "Android: Unlocked the Pro version via in-app purchase" |
*
* @param {Pro_User_Include_Content2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_include_content2 = /** @type {((inputs?: Pro_User_Include_Content2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Include_Content2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_include_content2(inputs)
	if (locale === "ar") return ar_pro_user_include_content2(inputs)
	if (locale === "de") return de_pro_user_include_content2(inputs)
	if (locale === "es") return es_pro_user_include_content2(inputs)
	if (locale === "fr") return fr_pro_user_include_content2(inputs)
	if (locale === "it") return it_pro_user_include_content2(inputs)
	if (locale === "ja") return ja_pro_user_include_content2(inputs)
	if (locale === "ko") return ko_pro_user_include_content2(inputs)
	if (locale === "pt_br") return pt_br_pro_user_include_content2(inputs)
	if (locale === "ru") return ru_pro_user_include_content2(inputs)
	if (locale === "th") return th_pro_user_include_content2(inputs)
	if (locale === "tr") return tr_pro_user_include_content2(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_include_content2(inputs)
	return zh_tw_pro_user_include_content2(inputs)
});